import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import {
  UXFB_ACTION_SCROLL,
  UXFB_CLIENT_EVENTS_CONFIG_KEY,
  UXFB_EVENT_ZHK_CATALOG,
  UXFB_PLATFORM,
  UXFB_SCROLL_ZHK_CATALOG_COUNT,
} from '../../constants/uxfb';
import { useApplicationContext } from '../../utils/applicationContext';
import { sendUXSEventWhenReady } from '../../utils/uxs';

/**
 * Высота 1px с компенсирующим отрицательным отступом: у элемента нулевой высоты intersectionRatio
 * всегда 0, и порог видимости ActionAfterViewObserver никогда не срабатывает.
 */
const sentinelStyle: React.CSSProperties = { height: 1, marginTop: -1 };

/**
 * Невидимый сентинел после N-й карточки ЖК в выдаче: когда он попадает во вьюпорт (пользователь
 * доскроллил ≥ N ЖК), шлёт UXFB-событие `zhk_catalog` с `action: scroll`. Одно событие на загрузку
 * страницы (dedupeKey) — переходы по пагинации и ремаунты дублей не дают.
 */
export const ScrollZhkCatalogUxfbTracker: React.FC = () => {
  const { config } = useApplicationContext();

  const handleViewed = React.useCallback(() => {
    if (config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    sendUXSEventWhenReady(
      UXFB_EVENT_ZHK_CATALOG,
      {
        platform: UXFB_PLATFORM,
        action: UXFB_ACTION_SCROLL,
        count: String(UXFB_SCROLL_ZHK_CATALOG_COUNT),
      },
      { dedupeKey: `${UXFB_EVENT_ZHK_CATALOG}:${UXFB_ACTION_SCROLL}` },
    );
  }, [config]);

  return (
    <ActionAfterViewObserver callback={handleViewed} triggerOnce wrapper={false}>
      <div style={sentinelStyle} data-mark="ScrollZhkCatalogUxfbTracker" />
    </ActionAfterViewObserver>
  );
};
